import React from 'react';
import { Typography } from '@material-ui/core';
import styles from '../InstructionsStyles';

const Instr14 = () => {
  return (
    <div style={styles.container}>
      <Typography variant="subtitle1" style={styles.madeBy}>
        Утвърдил: Габриела Илиева
      </Typography>

      <Typography variant="subtitle1" style={styles.madeBy}>
        Старши експерт &quot;Здравословна работна среда&quot;
      </Typography>

      <Typography variant="subtitle1" style={styles.title}>
        За безопасна работа при експлоатация на електрически уредби, ел. съоръжения и инсталации до
        1000 V
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>1. При експлоатация на електрически уредби</b>, ел. съоръжения и инсталации до 1000 V се
        допускат само лица, които са:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - навършили 18 години;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преминали са медицински преглед;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - преминали са начален инструктаж и инструктаж на работното място, периодичен и ежедневен
          инструктаж.
        </Typography>
      </div>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>2. Всички части на електрическите уредби</b> и съоръжения, които се намират в
        експлоатация (под напрежение), трябва да се изолират и ограждат по такъв начин, че да не
        дават възможност на хора без използването на помощни средства да се приближат или да се
        допират до опасни части.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>3. Под намиращи се в експлоатация </b>енергийни уредби и съоръжения се разбират такива
        енергийни уредби и съоръжения и консуматори на електрическа и топлинна и горива, които са в
        действие или са в топъл резерв цялостно или частично, или във всеки момент могат да бъдат
        включени в действие ръчно или автоматично.
      </Typography>

      <Typography variant="body1" style={styles.whiteSpace}>
        <b>4. Всички електрически машини </b>трябва да са:
      </Typography>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - със сигурно покрити с капаци клемни кутии;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - с обезопасени с капаци пусково-регулираща апаратура;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - с изолирани от случайно допиране на тоководещи части на контакти, щепсели и ключове;
        </Typography>
      </div>

      <div style={styles.whiteSpace}>
        <Typography variant="body2" style={styles.gap}>
          - с оградени въртящи се части (контактни пръстени, шайби, съединители, вентилатори и
          други).
        </Typography>
      </div>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>5. Електропроводимите части </b>на електрическите съоръжения, които в нормална
        експлоатация не са под напрежение, но могат в определен момент да се окажат под напрежение,
        трабва да са занулени.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>6. Пред всички електрически табла </b>трябва да има проверени и изпитани диелектрични
        килимчета.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>7. Замяната на предпазители </b>трябва да се извършва след изключване на напрежението.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>8. При невъзможност да се изключи напрежението</b>, замяната на предпазителите под
        напрежение трябва да се извърши след изключване на товара със защитни очила и диелектрични
        ръкавици или изолационни клещи.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          9. <span style={styles.warning}>Забранява се </span>
        </b>
        подмяна на предпазители с нестандартни вложки или вложки на които номиналния ток не
        съответства на определения за съответния токов кръг.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          10. <span style={styles.warning}>Забранява се </span>
        </b>
        работа с нестандартни или неизправни електрически инструменти, преносими лампи,
        трансформатори и др.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>11. Свалянето, почистването и поставянето на електрически лампи </b>
        от осветителните тела да се извършва само от инструктирани лица и при изключено напрежение.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>12. Свалянето и поставянето на лампи </b>от подвижни осветителни тела да става само при
        изваден щепсел.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>13. Експлоатация на електрически потребители</b> да се спазва строго изискванията за
        безопасна работа дадени от производителя.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>14. Да не се допуска </b>работа с неизправни електрически щепселни съединения, ключове,
        шнурове и кабели.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>15. Когато по време на експлоатация </b>на електрически уреди, апарати, машини и др. бъде
        забелязана неизправност или каквото и да е отклонение от нормалната работа, незабавно да се
        прекрати работа и да се уведоми съответната сервизна база.
      </Typography>
      <Typography variant="body1" style={styles.whiteSpace}>
        <b>
          16. <span style={styles.warning}>Забранява се </span>
        </b>
        на обслужващия персонал да отстранява повреди по електрическите електрически уреди, апарати,
        машини и др.
      </Typography>

      <Typography style={styles.date}>
        <b>7.10.2024г.</b>
      </Typography>
    </div>
  );
};
export default Instr14;
